import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "FullscreenExit"
});
const _hoisted_1 = {
  class: "icon",
  width: "200px",
  height: "190.51px",
  viewBox: "0 0 1075 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M324.07142861 679.31428583H212.36428554v-48.55714277h194.29285695v194.29285694h-48.57857141v-111.70714307l-160.28571357 160.28571445L163.78571415 839.62142891z m407.99999971 0l160.28571445 160.28571446L858.35000029 873.60714277l-160.28571444-160.28571445v111.70714306h-48.55714279v-194.27142832h194.29285693v48.57857139h-111.70714306zM324.07142861 339.32857109L163.78571415 179.04285751 197.79285751 145.03571415l160.28571357 160.28571446V193.61428555h48.57857141v194.29285692H212.36428554v-48.57857138h111.70714307z m407.99999971 0h111.70714306v48.5785714h-194.27142832V193.61428555h48.57857138v111.70714306L858.3714289 145.03571415l34.00714248 34.00714336-160.28571445 160.28571358z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var fullscreenExit = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "E:\\gitlab\\sgui-plus-icon\\packages\\vue\\src\\fullscreen-exit.vue"]]);

export { fullscreenExit as default };
